import { Inject, Injectable, Optional } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { FEATURE_CONFIG } from './feature-toggles.config';
import { FeatureToggler, FeatureValue } from './feature-toggler';
import { EvaluationContext } from './models/feature-flag.model';

export function LocalFeatureTogglerRepositoryFactory(featureConfig?: Record<string, FeatureValue>) {
  return new LocalFeatureTogglerRepository(featureConfig ?? {});
}

@Injectable()
export class LocalFeatureTogglerRepository implements FeatureToggler {
  #featuresState = new Subject<Record<string, boolean | FeatureValue>>();
  #context = new BehaviorSubject<Record<string, any>>({ email: null });

  public _state = {} as Record<string, FeatureValue>;

  setState(state: Record<string, FeatureValue>) {
    this._state = state;
    this.#featuresState.next(state);
  }

  get state() {
    return this._state;
  }
  /**
   * Observable that emits when feature flags state is changed
   */
  featureStateChanged$ = this.#featuresState.pipe(map(() => undefined));

  constructor(@Optional() @Inject(FEATURE_CONFIG) featureConfig?: Record<string, FeatureValue>) {
    this._state = featureConfig ?? {};
  }

  isFeatureEnabled(featureName: string): boolean {
    const feature: FeatureValue = this.state[featureName];

    if (feature == null) return false;

    if (typeof feature === 'boolean') {
      return feature;
    }

    return feature?.value;
  }

  /**
   * Identify the user context for feature flag evaluation
   * @param context The user context
   */
  identify(_: EvaluationContext | string): void {
    // In the local implementation, identify would usually be a no-op so empty to comply with the interface
  }

  get context() {
    return this.#context.value;
  }
}
